import _ from 'lodash'
import BearerToken from '../../lib/BearerToken'

const mutations = {
  appropriateness (state, appropriateness) {
    state.auth.user.appropriateness = appropriateness
  },

  authenticate (state, user) {
    state.auth.authenticated = true
    state.auth.error = ''
    state.auth.profile = user.profile
    state.auth.user = user
  },

  authenticated (state, data) {
    state.auth.authenticated = true
    state.auth.accessToken = data.accessToken
    state.auth.idToken = data.idToken
    state.auth.expiresAt = data.expiresIn * 1000 + new Date().getTime()

    localStorage.setItem('access_token', state.auth.accessToken)
    localStorage.setItem('id_token', state.auth.idToken)
    localStorage.setItem('expires_at', state.auth.expiresAt)
  },

  authorize (state, user) {
    state.auth._id = user._id
    state.auth.user = user
    state.auth.profile = user.profile

    localStorage.setItem('_id', user._id)
  },

  // authorize (state, { _id, token }) {
  //   state.auth._id = _id
  //   state.auth.token = token
  //   state.auth.invalid = false

  //   BearerToken.store({ _id, token })
  // },

  change (state, user) {
    const { email, role, permissions, appropriateness, accounts } = user

    state.auth.user.email = email
    state.auth.user.role = role
    state.auth.user.permissions = permissions
    state.auth.user.appropriateness = appropriateness
    state.auth.user.accounts = accounts
  },

  checked (state, checked) {
    state.auth.checked = checked
  },

  clear (state) {
    state.auth._id = null
    state.auth.token = null

    BearerToken.destroy()
  },

  error (state, { data, message }) {
    // TODO segregate this functionality
    const errors = {}

    if (data) {
      _.forIn(data, ({ field, message }) => {
        errors[field] = message
      })
    }

    state.auth.error = message || ''
    state.auth.errors = errors
  },

  errorOnOnboard (state, error) {
    state.auth.errorOnOnboard = error.message
  },

  isOnboardPending (state, pending) {
    state.auth.isOnboardPending = pending
  },

  logout (state) {
    // state.auth.authenticated = false
    // state.auth.checked = false
    // state.auth.user = {}

    state.authenticated = false
    state.accessToken = null
    state.idToken = false

    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
  },

  onboard (state, onboard) {
    state.auth.onboard = onboard
  },

  profile (state, profile) {
    state.auth.user.profile = profile
    state.auth.profile = profile
  },

  registered (state, { user }) {
    state.auth.registered = user
  },

  unauthorize (state) {
    state.auth.authenticated = false
    state.auth.accessToken = null
    state.auth.idToken = null
    state.auth.expiresAt = null

    localStorage.removeItem('_id')
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
  },

  user (state, user) {
    state.auth.user = user
  }
}

export default mutations
